export const clearAndLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
}